import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

export const useLanguageStore = create(
  persist(
    (set, get) => ({
      currentLanguageId: null,
      currentLanguageCode: null,
      _hasHydrated: false,
      setCurrentLanguage: (languageId, languageCode) => {
        set({
          currentLanguageId: languageId,
          currentLanguageCode: languageCode,
        })
      },
      initializeLanguage: (languages) => {
        const current = get()

        if (current.currentLanguageId && current.currentLanguageCode) {
          return
        }

        const defaultLang = languages.find((l) => l.is_default) || languages[0]
        if (defaultLang) {
          set({
            currentLanguageId: defaultLang.id,
            currentLanguageCode: defaultLang.code,
          })
        }
      },
      setHasHydrated: (state) => {
        set({
          _hasHydrated: state,
        })
      },
    }),
    {
      name: 'ginger-cms-language',
      storage: createJSONStorage(() => localStorage),
      onRehydrateStorage: () => (state) => {
        state?.setHasHydrated(true)
      },
    }
  )
)
